import { styled } from "@mui/material/styles";
import type { ReactNode } from "react";

/** Full-viewport shell: centers the extension “session validated” card (same canvas as login). */
const SessionValidationScreen = styled("div")({
	background: "#FFFFFF",
	minHeight: "100vh",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	padding: "32px 16px",
	boxSizing: "border-box",
	fontFamily: "Work Sans, -apple-system, BlinkMacSystemFont, sans-serif"
});

/** Card body — width, padding, radius aligned with `CoAppLoginCard`. */
const SessionValidationCard = styled("div")({
	width: "100%",
	maxWidth: 440,
	background: "#FFFFFF",
	borderRadius: 16,
	boxShadow: "none",
	padding: "40px 36px 32px",
	display: "flex",
	flexDirection: "column",
	alignItems: "stretch",
	gap: 24,
	boxSizing: "border-box"
});

type SessionValidationCardStructureProps = {
	children: ReactNode;
};

/**
 * Browser-extension “you’re signed in” view: centered white page + max-width card.
 * Wrap content (message, actions) inside the card.
 */
export function SessionValidationCardStructure({ children }: SessionValidationCardStructureProps) {
	return (
		<SessionValidationScreen>
			<SessionValidationCard>{children}</SessionValidationCard>
		</SessionValidationScreen>
	);
}
